/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:26 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

import {MyComplexObjectRef} from '../model/my-complex-object-ref.model' ;
import {MyComplexObject} from '../model/my-complex-object.model' ;
import {PAKKK_EXCEPTIONTESTS_TOKEN} from './pakkk-exceptiontests.token' ;
import {ExampleComplexObjectRefException590} from './../model/example-complex-object-ref-exception590.response' ;
import {ExampleComplexObjectRefException591} from './../model/example-complex-object-ref-exception591.response' ;
import {ExampleComplexObjectRefException592} from './../model/example-complex-object-ref-exception592.response' ;
import {ExampleIntegerException490} from './../model/example-integer-exception490.response' ;
import {ExampleIntegerException491} from './../model/example-integer-exception491.response' ;
import {ExampleIntegerException492} from './../model/example-integer-exception492.response' ;
import {ExampleBooleanException490} from './../model/example-boolean-exception490.response' ;
import {ExampleBooleanException491} from './../model/example-boolean-exception491.response' ;
import {ExampleBooleanException492} from './../model/example-boolean-exception492.response' ;
import {ExampleComplexObjectException590} from './../model/example-complex-object-exception590.response' ;
import {ExampleComplexObjectException591} from './../model/example-complex-object-exception591.response' ;
import {ExampleComplexObjectException592} from './../model/example-complex-object-exception592.response' ;
import {ExampleStringException490} from './../model/example-string-exception490.response' ;
import {ExampleStringException491} from './../model/example-string-exception491.response' ;
import {ExampleStringException492} from './../model/example-string-exception492.response' ;
import {ExampleLongException490} from './../model/example-long-exception490.response' ;
import {ExampleLongException491} from './../model/example-long-exception491.response' ;
import {ExampleLongException492} from './../model/example-long-exception492.response' ;
import {ExampleDoubleException490} from './../model/example-double-exception490.response' ;
import {ExampleDoubleException491} from './../model/example-double-exception491.response' ;
import {ExampleDoubleException492} from './../model/example-double-exception492.response' ;
import {ExampleFloatException490} from './../model/example-float-exception490.response' ;
import {ExampleFloatException491} from './../model/example-float-exception491.response' ;
import {ExampleFloatException492} from './../model/example-float-exception492.response' ;
import {StandardHttpException} from './../utils/standard-http-exception.utils' ;
import {ParserValues} from '../utils/parser-values.utils' ;
import {Observable, throwError} from 'rxjs' ;
import {Injectable, Inject} from '@angular/core' ;
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http' ;
import {catchError} from 'rxjs/operators' ;

/**
 * ------------------------------------------------
 * @author API Rest Generator
 * ------------------------------------------------
 */
@Injectable()
export class PakkkExceptiontestsService
{
	/** Constant - API Version - Key */
	static API_VERSION_KEY   = "PakkkExceptiontestsApiVersion" ;

	/** Constant - API Version - Value */
	static API_VERSION_VALUE = "4.0.0" ;

	constructor(@Inject(PAKKK_EXCEPTIONTESTS_TOKEN) private baseURI: string, private http: HttpClient)
	{
		// Empty method
	}
	
	getBaseURI(scheme: string)
	{
        return scheme + "://" + this.baseURI + "/" ;
    }

	exampleDouble(scheme: string) : Observable<number>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleDoubleValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleDoubleFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleDoubleHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<number>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.floatParser(contentValue) ;
							return throwError(new ExampleDoubleException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.floatParser(contentValue[i1]) ;
							}
							return throwError(new ExampleDoubleException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.floatParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleDoubleException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleDoubleValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleDoubleFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleDouble/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleDoublePathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleDoubleQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleDoublePathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleDoubleQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleDoubleHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleBoolean(scheme: string) : Observable<boolean>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleBooleanValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleBooleanFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleBooleanHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<boolean>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.booleanParser(contentValue) ;
							return throwError(new ExampleBooleanException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.booleanParser(contentValue[i1]) ;
							}
							return throwError(new ExampleBooleanException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.booleanParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleBooleanException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleBooleanValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleBooleanFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleBoolean/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleBooleanPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleBooleanQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleBooleanPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleBooleanQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleBooleanHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleComplexObject(scheme: string) : Observable<MyComplexObject>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleComplexObjectValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleComplexObjectFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleComplexObjectHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<MyComplexObject>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 590)
						{
							var contentValue = error.error ;
							outcome = MyComplexObject.parse(contentValue) ;
							return throwError(new ExampleComplexObjectException590(outcome)) ;
						}
						else if (error.status == 591)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
				  		 		outcome[i1] = MyComplexObject.parse(contentValue[i1]) ;
							}
							return throwError(new ExampleComplexObjectException591(outcome)) ;
						}
						else if (error.status == 592)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
				  		 			outcome[i1][i2] = MyComplexObject.parse(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleComplexObjectException592(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleComplexObjectValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleComplexObjectFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleComplexObject/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleComplexObjectPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleComplexObjectQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleComplexObjectPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleComplexObjectQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleComplexObjectHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleString(scheme: string)	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleStringValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleStringFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleStringHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "text" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.stringParser(contentValue) ;
							return throwError(new ExampleStringException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.stringParser(contentValue[i1]) ;
							}
							return throwError(new ExampleStringException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.stringParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleStringException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleStringValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleStringFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleString/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleStringPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleStringQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleStringPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleStringQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleStringHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleComplexObjectRef(scheme: string) : Observable<MyComplexObjectRef>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleComplexObjectRefValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleComplexObjectRefFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleComplexObjectRefHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<MyComplexObjectRef>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 590)
						{
							var contentValue = error.error ;
							outcome = MyComplexObjectRef.parse(contentValue) ;
							return throwError(new ExampleComplexObjectRefException590(outcome)) ;
						}
						else if (error.status == 591)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
				  		 		outcome[i1] = MyComplexObjectRef.parse(contentValue[i1]) ;
							}
							return throwError(new ExampleComplexObjectRefException591(outcome)) ;
						}
						else if (error.status == 592)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
				  		 			outcome[i1][i2] = MyComplexObjectRef.parse(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleComplexObjectRefException592(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleComplexObjectRefValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleComplexObjectRefFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleComplexObjectRef/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleComplexObjectRefPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleComplexObjectRefQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleComplexObjectRefPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleComplexObjectRefQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleComplexObjectRefHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleInteger(scheme: string) : Observable<number>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleIntegerValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleIntegerFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleIntegerHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<number>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.numberParser(contentValue) ;
							return throwError(new ExampleIntegerException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.numberParser(contentValue[i1]) ;
							}
							return throwError(new ExampleIntegerException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.numberParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleIntegerException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleIntegerValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleIntegerFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleInteger/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleIntegerPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleIntegerQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleIntegerPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleIntegerQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleIntegerHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleFloat(scheme: string) : Observable<number>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleFloatValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleFloatFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleFloatHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<number>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.floatParser(contentValue) ;
							return throwError(new ExampleFloatException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.floatParser(contentValue[i1]) ;
							}
							return throwError(new ExampleFloatException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.floatParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleFloatException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleFloatValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleFloatFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleFloat/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleFloatPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleFloatQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleFloatPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleFloatQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleFloatHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}


	exampleLong(scheme: string) : Observable<number>	{
		// Local Reference of this class
		var self = this ;
		
		// Validate the input scheme
		var isValidInputScheme = this.exampleLongValidateScheme(scheme) ;
		if (!isValidInputScheme)
		{
			throw new Error("Angular6 Thin2 Client contains an invalid input scheme: '" + scheme + "'. Please use one of the defined in the specification.") ;
		}


		// Assign a final URL with all the parameters assigned to
		var fullURL			 = this.exampleLongFullUrl(scheme) ;
		
		// Set the header parameters
		var headerParameters = this.exampleLongHeaderAssignment() ;

		let formDataInstance = null ;
		// Return the observable
		return this.http
				   .request<number>("GET", fullURL, { body: formDataInstance, headers: headerParameters, responseType : "json" })
				   .pipe(catchError((error: HttpErrorResponse) => {
					    let outcome ;

						if (error.status == 490)
						{
							var contentValue = error.error ;
							outcome = ParserValues.numberParser(contentValue) ;
							return throwError(new ExampleLongException490(outcome)) ;
						}
						else if (error.status == 491)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				outcome[i1] = ParserValues.numberParser(contentValue[i1]) ;
							}
							return throwError(new ExampleLongException491(outcome)) ;
						}
						else if (error.status == 492)
						{
							var contentValue = error.error ;
			  		 		outcome = [] ;

				  		 	var length1 = contentValue.length ;
				  		 	for (var i1=0 ; i1 < length1 ; i1++)
				  		 	{
								outcome[i1] = [] ;
		  		 				var length2 = contentValue[i1].length ;
			  		 			for (var i2=0 ; i2 < length2 ; i2++)
			  		 			{
	  		 						outcome[i1][i2] = [] ;
		  		 					outcome[i1][i2] = ParserValues.numberParser(contentValue[i1][i2]) ;
								}
							}
							return throwError(new ExampleLongException492(outcome)) ;
						}
						else
						{
							var contentValue = error.error ;
							outcome = self.generateStandardHttpExceptionFromErrorInstance(error.status, contentValue) ;
							return throwError(outcome) ;
						}
					}));
	}
	
	/**
	 * Validate the input scheme with the expected for this 
	 */
	exampleLongValidateScheme(scheme)
	{
		return scheme == "http" ;
	}
	
	/**
	 * The following method get the full URL
	 */
	exampleLongFullUrl(scheme: string)
	{
		// URL with scheme
		var urlWithScheme	 = this.getBaseURI(scheme) + "api/exampleLong/" ;

		// Replace every path parameter with the input value
		var urlWithPaths     = this.exampleLongPathAssignment(urlWithScheme) ;
		
		// Replace every query parameter with the input value
		var queryParameters  = this.exampleLongQueryAssignment() ;
			
		// Return a final URL with all the parameters assigned to
		return urlWithPaths + queryParameters ;	 
	}

	/**
	 * The following method assign every path parameter with the value
     */
	exampleLongPathAssignment(urlWithScheme: string)
	{

		return urlWithScheme ;
	}
	
	/**
	 * The following method assign every query parameter with the value
     */	
	exampleLongQueryAssignment()
	{
		var outcome = "?" ;


		return outcome ;
	}
	
	/**
	 * The following method assign every header parameter with the value
     */	
	exampleLongHeaderAssignment()
	{
		let headers = new HttpHeaders() ;
		
		// Add the "ApiVersion" header
		headers = headers.set(PakkkExceptiontestsService.API_VERSION_KEY, PakkkExceptiontestsService.API_VERSION_VALUE) ;



		return headers ;
	}



	/**
	 * @param statusCode with the status code
	 * @param error with the instance of the error
	 * @return a new instance of standard HTTP exception
	 */
	generateStandardHttpExceptionFromErrorInstance(statusCode, error)
	{
		var errorString ;
		var message     ;
		var exception   ;
		var path 	    ;
		var timestamp   ;
		
		if (error != undefined)
		{
			errorString = error.error ;
			message     = error.message ;
			exception   = error.exception ;
			path 	    = error.path ;
			timestamp   = error.timestamp ;
		}
	
		return this.generateStandardHttpException(statusCode, errorString, message, exception, path, timestamp) ;
	}

	/**
	 * @param statusCode  with the status code
	 * @param errorString with the error message
	 * @param message 	  with the exception message
	 * @param exception   with the stack trace error
	 * @param path        with the path error
	 * @param timestamp   with the timestamp
	 * @return a new instance of standard HTTP exception
	 */
    generateStandardHttpException(statusCode: number, errorString: string, message: string, exception: string, path: string, timestamp: number)
    {
    	var standardHttpException = new StandardHttpException(statusCode) ;

		standardHttpException.setError(errorString) ;
		standardHttpException.setMessage(message) ;
		standardHttpException.setException(exception) ;
		standardHttpException.setPath(path) ;
		standardHttpException.setTimestamp(timestamp) ;
					
        return standardHttpException ;
    }
}
